/**
 * Status Tab
 *
 * Presentational tab control for a single TODO status (Completed, In Progress,
 * or Backlog). Renders a button with an active/selected state and forwards
 * clicks to the parent via `onSelect`. The list-level filtering, default tab
 * selection, and empty-state handling live in `TodoList`.
 *
 * Requirements: 6.1, 6.2
 */

import React from 'react';
import './StatusTab.css';

const StatusTab = ({ status, count, active, onSelect }) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(status);
    }
  };

  return (
    <button
      type="button"
      role="tab"
      aria-selected={active ? 'true' : 'false'}
      className={`status-tab ${active ? 'status-tab--active' : ''}`.trim()}
      onClick={handleClick}
    >
      <span className="status-tab__label">{status}</span>
      {typeof count === 'number' && (
        <span className="status-tab__count">{count}</span>
      )}
    </button>
  );
};

export default StatusTab;
